var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArticleDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.591 5.52725C19.8822 5.23266 19.8795 4.75779 19.5849 4.4666C19.2903 4.17541 18.8154 4.17817 18.5243 4.47275L19.591 5.52725ZM4.68563 18.4728C4.39444 18.7674 4.39719 19.2422 4.69178 19.5334C4.98636 19.8246 5.46123 19.8218 5.75242 19.5273L4.68563 18.4728ZM5.75243 4.47275C5.46124 4.17817 4.98638 4.17541 4.69179 4.4666C4.39721 4.75779 4.39445 5.23266 4.68564 5.52725L5.75243 4.47275ZM18.5243 19.5273C18.8155 19.8218 19.2903 19.8246 19.5849 19.5334C19.8795 19.2422 19.8823 18.7674 19.5911 18.4728L18.5243 19.5273ZM18.5243 4.47275L4.68563 18.4728L5.75242 19.5273L19.591 5.52725L18.5243 4.47275ZM4.68564 5.52725L18.5243 19.5273L19.5911 18.4728L5.75243 4.47275L4.68564 5.52725Z",
    fill: "#132029"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticleDelete);
export default __webpack_public_path__ + "static/media/articleDelete.a91e1f2e7b3779f35870ef956ec706b1.svg";
export { ForwardRef as ReactComponent };